import { Routes, Route } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import { useAuthStore } from './store/authStore'
import Login from './pages/auth/Login'
import EmailVerify from './pages/auth/EmailVerify'
import Onboarding from './pages/auth/Onboarding'
import Waitlist from './pages/auth/Waitlist'
import Home from './pages/Home'
import ProtectedRoute from './components/auth/ProtectedRoute'
import FacebookSuccess from './pages/auth/FacebookSuccess';


import CreatorDashboard from './pages/creator/Dashboard'
import CreatorVideoDetails from './pages/creator/VideoDetails'
import VideoLibrary from './pages/creator/VideoLibrary'
import UploadVideo from './pages/creator/UploadVideo'
import BrowseCampaigns from './pages/creator/BrowseCampaigns'
import CreatorProfile from './pages/creator/CreatorProfile';
import CreatorOrg from './pages/creator/CreatorOrg';
import VideoProcessing from './pages/creator/VideoProcessing';
import PublishSocial from './pages/creator/PublishSocial';
import CampaignDetails from './pages/creator/CampaignDetails';
import MyCampaigns from './pages/creator/MyCampaigns';
import SocialConnect from './pages/creator/SocialConnect'
import SocialConnected from './pages/creator/SocialConnected';
import SocialCallback from './pages/SocialCallback';
import Legal_page from './pages/legal/LegalPage';


import BrandDashboard from './pages/brand/Dashboard'
import BrandAssets from './pages/brand/Assets'
import BrandCampaigns from './pages/brand/Campaigns'
import BrandCampaignNew from './pages/brand/CampaignNew'
import BrandCampaignDetails from './pages/brand/CampaignDetails'
import CreateCampaign from './pages/brand/CreateCampaign'
import CampaignsList from './pages/brand/CampaignsList'
import CampaignDetailsNew from './pages/brand/CampaignDetails'
import BrandCreatorVcamp from './pages/brand/CreatorVcamp'
import AssetLibrary from './pages/brand/AssetLibrary'
import AssetUpload from './pages/brand/AssetUpload'
import Profile from './pages/brand/Profile'
import EditProfile from './pages/brand/EditProfile'

function App() {
  useAuth()
  const { email_unverified, needs_onboarding, org_disabled } = useAuthStore()

  
  if (window.location.pathname.startsWith('/legal/'))
    return (
      <Routes>
        <Route path="/legal/:slug" element={<Legal_page />} />
      </Routes>
    )

  if (email_unverified)
    return <EmailVerify />
  if (needs_onboarding)
    return <Onboarding />
  if (org_disabled)
    return <Waitlist />

  return (
      <Routes>
        {}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/auth/facebook-success" element={<FacebookSuccess />} />
        <Route path="/social/callback" element={<SocialCallback />} />
        <Route path="/legal/:slug" element={<Legal_page />} />
        
        {}
        <Route path="/creator/dashboard" element={
          <ProtectedRoute userType="creator">
            <CreatorDashboard />
          </ProtectedRoute>
        } />

        <Route path="/creator/social" element={<SocialConnect />} />
        <Route path="/creator/social-connected" element={<SocialConnect />} />
        <Route
         path="/creator/social-connected"
        element={
          <ProtectedRoute userType="creator">
            <SocialConnected />
          </ProtectedRoute>
          }
        />

        <Route path="/creator/upload" element={
          <ProtectedRoute userType="creator">
            <UploadVideo />
          </ProtectedRoute>
        } />

        <Route path="/creator/videos" element={
          <ProtectedRoute userType="creator">
            <VideoLibrary />
          </ProtectedRoute>
        } />
        
        <Route path="/creator/videos/:id" element={
          <ProtectedRoute userType="creator">
            <CreatorVideoDetails />
          </ProtectedRoute>
        } />

                <Route
          path="/creator/video-processing"
          element={
            <ProtectedRoute userType="creator">
              <VideoProcessing />
            </ProtectedRoute>
          }
        />

        <Route
          path="/creator/publish-social"
          element={
            <ProtectedRoute userType="creator">
              <PublishSocial />
            </ProtectedRoute>
          }
        />

        <Route path="/creator/campaigns" element={
          <ProtectedRoute userType="creator">
            <BrowseCampaigns />
          </ProtectedRoute>
        } />

        <Route path="/creator/campaigns/:campaignId" element={
            <ProtectedRoute userType="creator">
              <CampaignDetails />
            </ProtectedRoute>
          }
        />

        <Route path="/creator/profile"
        element={
          <ProtectedRoute userType="creator">
            <CreatorProfile />
          </ProtectedRoute>
        }
      />
        <Route path="/creator/org"
        element={
          <ProtectedRoute userType="creator">
            <CreatorOrg />
          </ProtectedRoute>
        }
      />
        
        <Route path="/creator/my-campaigns" element={
          <ProtectedRoute userType="creator">
            <MyCampaigns />
          </ProtectedRoute>
        } />

        {}
        <Route path="/brand/dashboard" element={
          <ProtectedRoute userType="brand">
            <BrandDashboard />
          </ProtectedRoute>
        } />
        
        {}
        <Route path="/brand/campaigns" element={
          <ProtectedRoute userType="brand">
            <CampaignsList />
          </ProtectedRoute>
        } />
        
        <Route path="/brand/campaigns/:id" element={
          <ProtectedRoute userType="brand">
            <CampaignDetailsNew />
          </ProtectedRoute>
        } />

        <Route path="/brand/campaigns/:campaign_id/creator/:vcamp_id" element={
          <ProtectedRoute userType="brand">
            <BrandCreatorVcamp />
          </ProtectedRoute>
        } />

        <Route path="/brand/create-campaign" element={
          <ProtectedRoute userType="brand">
            <CreateCampaign />
          </ProtectedRoute>
        } />
        <Route path="/brand/create-campaign/:id" element={
          <ProtectedRoute userType="brand">
            <CreateCampaign />
          </ProtectedRoute>
        } />
        
        {}
        <Route path="/brand/campaigns-old" element={
          <ProtectedRoute userType="brand">
            <BrandCampaigns />
          </ProtectedRoute>
        } />
        
        <Route path="/brand/campaigns/new" element={
          <ProtectedRoute userType="brand">
            <BrandCampaignNew />
          </ProtectedRoute>
        } />
        
        <Route path="/brand/campaigns-old/:id" element={
          <ProtectedRoute userType="brand">
            <BrandCampaignDetails />
          </ProtectedRoute>
        } />
        
        {}
        <Route path="/brand/assets" element={
          <ProtectedRoute userType="brand">
            <AssetLibrary />
          </ProtectedRoute>
        } />
        
        <Route path="/brand/upload-asset" element={
          <ProtectedRoute userType="brand">
            <AssetUpload />
          </ProtectedRoute>
        } />
        
        {}
        <Route path="/brand/assets-old" element={
          <ProtectedRoute userType="brand">
            <BrandAssets />
          </ProtectedRoute>
        } />

        {}
        <Route path="/brand/profile" element={
          <ProtectedRoute userType="brand">
            <Profile />
          </ProtectedRoute>
        } />

        <Route path="/brand/profile/edit" element={
          <ProtectedRoute userType="brand">
            <EditProfile />
          </ProtectedRoute>
        } />
      </Routes>
  )
}

export default App